import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CountryCode, LanguageCode } from 'config/pais';

const initialState: { lang: LanguageCode; country: CountryCode } = { lang: 'es', country: 'CL' };

const langCountryUserSlice = createSlice({
	name: 'langCountryUser',
	initialState,
	reducers: {
		setLangCountryUser: (state, action: PayloadAction<{ lang: LanguageCode; country: CountryCode }>) => {
			return action.payload;
		}
	}
});

export const { setLangCountryUser } = langCountryUserSlice.actions;

export default langCountryUserSlice.reducer;
